export const PROJECT_TRASH_PREFIX_URL = '/project-trash'
